import { provideZoneChangeDetection } from "@angular/core";
import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import {
  applyHomeLetterLogoCssVar,
  applyStudentThemeTokens,
  readCachedStudentTheme,
  updateFavicon,
} from './app/core/theme/student-theme-tokens-applier';
import { resolveBrandingLogoUrl } from './app/core/theme/branding-logo-source';
import { AppTheme } from './app/core/theme/app-theme';

const cached = readCachedStudentTheme();
if (cached?.tokens) {
  applyStudentThemeTokens(cached.tokens);
  const homeLetter = resolveBrandingLogoUrl(
    cached.homeLetterLogoUrl,
    AppTheme.homeLetterLogoSrc
  );
  applyHomeLetterLogoCssVar(homeLetter);
  updateFavicon(homeLetter);
}

platformBrowser()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch((err) => console.error(err));
